{
  "Branding_Labels_BrandingEnabled": "Habilitar a marca para este CME?",
  "Branding_Tab_Name_Colours": "Cores",
  "Branding_Tab_Name_AdditionalColours": "Outras cores",
  "Branding_Tab_Name_Imagery": "Imagens",
  "Branding_Tab_Name_Languages": "Linguagem",
  "Branding_Tab_Name_SSOButtons": "Botões SSO",
  "Branding_Tab_Name_Links": "Ligações",
  "Branding_Labels_DarkMode": "(Modo escuro)",
  "Branding_Subtitles_ColourPalette": "Paleta de cores",
  "Branding_Labels_PrimaryColour": "Primário",
  "Branding_Labels_SecondaryColour": "Secundário",
  "Branding_Labels_TertiaryColour": "Terciário",
  "Branding_Subtitles_HeaderSidebarColours": "Cores do cabeçalho\/barra lateral",
  "Branding_Labels_HeaderSidebarBackgroundColour": "Fundo do cabeçalho\/barra lateral",
  "Branding_Labels_HeaderSidebarBackgroundContrastColour": "Destaque do cabeçalho\/barra lateral",
  "Branding_Labels_HeaderSidebarIconColour": "Ícones de cabeçalho\/barra lateral",
  "Branding_Subtitles_RouterColours": "Cores do roteador",
  "Branding_Labels_RouterLoaderBackgroundColour": "Histórico do carregador de roteador",
  "Branding_Labels_RouterLoaderForegroundColour": "Carregador de roteador em primeiro plano",
  "Branding_Subtitles_DashboardColours": "Cores do painel",
  "Branding_Labels_Dashboard_1_BgColour": "Painel 1 Plano de fundo",
  "Branding_Labels_Dashboard_1_FgColour": "Painel 1 Primeiro Plano",
  "Branding_Labels_Dashboard_2_BgColour": "Fundo do painel 2",
  "Branding_Labels_Dashboard_2_FgColour": "Painel 2 Primeiro Plano",
  "Branding_Labels_Dashboard_3_BgColour": "Painel 3 Plano de fundo",
  "Branding_Labels_Dashboard_3_FgColour": "Painel 3 Primeiro Plano",
  "Branding_Labels_Dashboard_4_BgColour": "Painel 4 Plano de fundo",
  "Branding_Labels_Dashboard_4_FgColour": "Painel 4 Primeiro Plano",
  "Branding_Labels_Dashboard_5_BgColour": "Painel 5 Plano de fundo",
  "Branding_Labels_Dashboard_5_FgColour": "Painel 5 Primeiro Plano",
  "Branding_Labels_Dashboard_6_BgColour": "Painel 6 Plano de fundo",
  "Branding_Labels_Dashboard_6_FgColour": "Painel 6 Primeiro Plano",
  "Branding_Subtitles_AuthColours": "Cores de autorização",
  "Branding_Labels_Auth_Subtitle_HighlightColour": "Cor de destaque da autorização",
  "Branding_Subtitles_InsightsColours": "Insights Cores",
  "Branding_Labels_Insights_Stat_1_Colour": "Estatísticas de Insights 1",
  "Branding_Labels_Insights_Stat_2_Colour": "Insights Stat 2",
  "Branding_Labels_Insights_Stat_3_Colour": "Insights Stat 3",
  "Branding_Labels_Insights_Stat_4_Colour": "Insights Stat 4",
  "Branding_Labels_Insights_Stat_5_Colour": "Estatísticas de Insights 5",
  "Branding_Labels_Insights_Percentage_Increase": "Indicador de Mudança - Melhoria",
  "Branding_Labels_Insights_Percentage_Decrease": "Indicador de Mudança - Declínio",
  "Branding_Labels_Insights_Percentage_NoChange": "Indicador de Nenhuma Mudança",
  "Branding_Labels_Insights_Quick_BusiestDay": "Insights sobre o dia mais movimentado",
  "Branding_Labels_Insights_Quick_BusiestTime": "Insights Horário de maior movimento",
  "Branding_Labels_Highlights_MostCalled": "Destaques Mais Chamados",
  "Branding_Labels_Highlights_MostAnsweredCalls": "Destaques Chamadas Mais Atendidas",
  "Branding_Subtitles_CompanyLogos": "Logotipos da empresa",
  "Branding_Labels_Imagery_MainLogo": "Logotipo principal (para fundo escuro)",
  "Branding_Labels_Imagery_MainLogo_White": "Logotipo principal (para fundo branco)",
  "Branding_Labels_Imagery_Favicon": "Favicon (arquivo .ico)",
  "Branding_Labels_Imagery_SquareLogo": "Logotipo quadrado",
  "Branding_Labels_Imagery_BroadworksLogo": "Logotipo da Broadworks",
  "Branding_Subtitles_Authorisation": "Imagens de Autorização",
  "Branding_Labels_Imagery_AuthBg": "Fundo de autorização (imagem ou vídeo)",
  "Branding_Subtitle_AuthLanguages": "Página de login",
  "Branding_Labels_AuthTitle": "Subtítulo da página de login",
  "Branding_Labels_AuthTitle2": "Linha 2 da legenda da página de login",
  "Branding_Subtitle_Broadworks": "Obras amplas",
  "Branding_Labels_BroadworksName": "Nome Broadworks",
  "Branding_Subtitle_SSOButtons": "Botões SSO",
  "Branding_Labels_SSOIcon": "Ícone",
  "Branding_Labels_SSOLabel": "Rótulo",
  "Branding_Labels_SSOUrl": "URL",
  "Branding_Labels_MainSiteLink": "Link do site principal",
  "Branding_Validation_MustBeValidURL": "Deve ser um URL válido",
  "Branding_SSO_Buttons_Add": "Botão Adicionar SSO",
  "Branding_SSO_Buttons_Remove": "Remover botão SSO",
  "Branding_Labels_VanityURL": "URL",
  "Branding_ResetButton": "Redefinir para a versão anterior",
  "Branding_RestoreCurrentVersion": "Voltar para a versão atual",
  "Branding_ApplyPreviewButton": "Clique para visualizar",
  "Branding_PreviewButton": "Há uma versão de rascunho disponível. Clique para visualizar",
  "Branding_DeletePreview": "Excluir visualização",
  "Branding_UndoChanges": "Limpar alterações atuais",
  "Branding_Required_Message": "Este campo é obrigatório",
  "Branding_Submission_Line1": "Estamos gerando sua marca para você",
  "Branding_Submission_Line2": "Isso pode levar alguns segundos",
  "Branding_Validation_MaxWordLength": "Nenhuma palavra deve exceder {} caracteres",
  "Branding_Validation_MaxLength": "Não deve exceder {} caracteres",
  "NAME": "BrandingLanguage"
}